import { baseApi } from "../../../../app/api";
import type { RawFeaturedContentIds } from "../../../../types/api/customRestApi/customRestApiEndpointsTypes";
import type { FeaturedContentData } from "../types/featuredApiTypes";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const featuredApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Fetches the IDs of featured content (products, categories, tags).
     * Automatically transforms snake_case API response to camelCase.
     */
    getFeaturedContentIds: builder.query<FeaturedContentData, void>({
      query: () => ({
        url: `${CUSTOM_REST_API_BASE}/featured-ids`,
      }),
      transformResponse: (
        response: RawFeaturedContentIds,
      ): FeaturedContentData => {
        return {
          productIds: response.product_ids || [],
          categoryIds: response.category_ids || [],
          tagIds: response.tag_ids || [],
        };
      },
      providesTags: ["Product"], // B2B oturumu güncellendiğinde refetch tetikler
      keepUnusedDataFor: 600, // 10 minutes
    }),
  }),
});

export const { useGetFeaturedContentIdsQuery } = featuredApi;
